export type ThemeChoice = 'light' | 'dark' | 'system';
const KEY = 'meradiya.admin.theme';

export function loadTheme(): ThemeChoice {
  try {
    // ?theme=light|dark|system (shareable link / screenshots); persisted like the in-app picker
    const fromUrl = new URLSearchParams(window.location.search).get('theme');
    if (fromUrl === 'light' || fromUrl === 'dark' || fromUrl === 'system') {
      localStorage.setItem(KEY, fromUrl);
      return fromUrl;
    }
    return (localStorage.getItem(KEY) as ThemeChoice) || 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(t: ThemeChoice): void {
  const root = document.documentElement;
  if (t === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', t);
  try {
    localStorage.setItem(KEY, t);
  } catch {
    /* ignore */
  }
}
